import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Politique de confidentialité" lastUpdate="13 février 2026">
      <p>Cette politique décrit la manière dont <strong>ECOLOVALO</strong> (responsable de traitement) collecte, utilise et protège vos données personnelles sur la plateforme <strong>fripri.com</strong>, conformément au Règlement Général sur la Protection des Données (RGPD – UE 2016/679) et à la loi Informatique et Libertés modifiée.</p>

      <h2>1. Responsable de traitement</h2>
      <p>ECOLOVALO – Association déclarée, SIREN 801 257 593, 5 Boulevard Galliéni, 92390 Villeneuve-la-Garenne, France.<br/>
      Contact RGPD : <a href="mailto:direction@fripri.com">direction@fripri.com</a></p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons les catégories de données suivantes :</p>
      <ul>
        <li><strong>Données d’identification</strong> : nom, prénom, email, photo de profil (optionnelle)</li>
        <li><strong>Données de connexion</strong> : mot de passe (haché bcrypt), date d’inscription, historique de connexion</li>
        <li><strong>Données de transaction</strong> : commandes, paiements (via Stripe), historique d’achat/vente</li>
        <li><strong>Données de livraison</strong> : point relais sélectionné, adresse postale (si demandée), numéro de suivi</li>
        <li><strong>Données de communication</strong> : messages envoyés via la messagerie interne, avis publiés</li>
        <li><strong>Données techniques</strong> : adresse IP, identifiant de session, type de navigateur, données de tracking d’expédition</li>
      </ul>

      <h2>3. Finalités et bases légales</h2>
      <table>
        <thead><tr><th>Finalité</th><th>Base légale</th></tr></thead>
        <tbody>
          <tr><td>Création de compte, authentification</td><td>Exécution du contrat</td></tr>
          <tr><td>Traitement des commandes, paiements, livraisons</td><td>Exécution du contrat</td></tr>
          <tr><td>Envoi d’emails transactionnels (commandes, sécurité)</td><td>Exécution du contrat</td></tr>
          <tr><td>Notifications push (commandes, messages)</td><td>Consentement (opt-in navigateur)</td></tr>
          <tr><td>Gestion des litiges et de la fraude</td><td>Intérêt légitime</td></tr>
          <tr><td>Obligations comptables et fiscales</td><td>Obligation légale (10 ans)</td></tr>
        </tbody>
      </table>

      <h2>4. Sous-traitants et destinataires</h2>
      <p>Vos données peuvent être partagées avec nos sous-traitants, tous engagés par un contrat de sous-traitance conforme à l’article 28 du RGPD :</p>
      <ul>
        <li><strong>Stripe Payments Europe Ltd</strong> (Irlande) — traitement des paiements et des versements vendeurs. <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">Politique Stripe</a></li>
        <li><strong>Resend</strong> (Delaware, USA — clauses contractuelles types) — envoi d’emails transactionnels. <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noreferrer">Politique Resend</a></li>
        <li><strong>Mondial Relay</strong> (France) — expédition des colis et suivi. <a href="https://www.mondialrelay.fr/footer/politique-de-confidentialite/" target="_blank" rel="noreferrer">Politique Mondial Relay</a></li>
        <li><strong>MongoDB Inc.</strong> (Irlande) — hébergement de la base de données.</li>
        <li><strong>Emergent Labs</strong> (USA) — hébergement de l’application.</li>
      </ul>
      <p>Aucune donnée n’est cédée, vendue ou louée à des tiers à des fins commerciales.</p>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li>Compte utilisateur actif : tant que vous êtes inscrit</li>
        <li>Compte inactif depuis 3 ans : suppression automatique après notification</li>
        <li>Données de commande : 10 ans (obligation comptable)</li>
        <li>Messages internes : 2 ans après dernière activité</li>
        <li>Logs techniques : 12 mois maximum</li>
      </ul>

      <h2>6. Vos droits</h2>
      <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li><strong>Droit d’accès</strong> : obtenir une copie de vos données</li>
        <li><strong>Droit de rectification</strong> : corriger des informations inexactes (modifiable depuis votre Tableau de bord)</li>
        <li><strong>Droit à l’effacement</strong> : supprimer votre compte et vos données (hors obligations légales)</li>
        <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré et réutilisable</li>
        <li><strong>Droit d’opposition</strong> : vous opposer à un traitement fondé sur l’intérêt légitime</li>
        <li><strong>Droit à la limitation</strong> : suspendre temporairement un traitement</li>
      </ul>
      <p>Pour exercer vos droits, écrivez-nous à <a href="mailto:direction@fripri.com">direction@fripri.com</a>. Nous répondons sous 30 jours maximum (article 12 RGPD).</p>

      <h2>7. Sécurité</h2>
      <p>Vos données sont stockées de manière sécurisée :</p>
      <ul>
        <li>Mots de passe hachés avec bcrypt (jamais en clair)</li>
        <li>Communications chiffrées en HTTPS (TLS 1.3)</li>
        <li>Paiements traités par Stripe (PCI-DSS Level 1)</li>
        <li>Sauvegardes régulières et accès restreint aux équipes Fripri</li>
      </ul>

      <h2>8. Cookies</h2>
      <p>Fripri utilise uniquement des cookies essentiels au fonctionnement (authentification, session, panier). Aucun cookie de tracking marketing. Voir <a href="/cookies">Politique cookies</a>.</p>

      <h2>9. Réclamation</h2>
      <p>Vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l’Informatique et des Libertés) : <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noreferrer">cnil.fr/fr/plaintes</a>.</p>

      <h2>10. Modifications</h2>
      <p>Cette politique peut évoluer. La date de dernière mise à jour est affichée en haut de la page. Toute modification substantielle vous sera notifiée par email.</p>
    </LegalLayout>
  );
}
